export default class CreateGeneralLedgerMappingOverridesRequest {
    generalLedgerAccountMappingId: string;
    transactionType: string;
    state: string;
    debitGLAccountId: string;
    creditGLAccountId: string;
    subtransactionTypeId: string;
}